// extracted by mini-css-extract-plugin
export var orderDetails = "_ri-2";
export var orderImage = "_ri-1";
export var orderMeta = "_ri-3";
export var orderSummary = "_ri-0";
export var rightArrow = "_ri-4";